import { InjectionToken, ModuleWithProviders, NgModule } from '@angular/core';

import { StoreConfig } from '@ngrx/store';
import { StateStorageModule } from 'packages/sports/web/app/src/store-persist/state-storage.module';
import StoragePersister from 'packages/sports/web/app/src/store-persist/storage-persister';

import { IBetslipState, betslipFeatureKey } from '../../base/store/state';
import BetslipDisplayModeService from '../../digital/services/betslip-display-mode.service';
import { BetslipSavedStateValidatorService } from './betslip-saved-state-validator.service';
import BetslipStateLoaderService from './betslip-state-loader.service';
import { IBetslipSavedState } from './betslip-state-model';
import BetslipStateSaverService from './betslip-state-saver.service';

@NgModule({
    imports: [StateStorageModule.forFeature(betslipFeatureKey, BetslipStateSaverService)],
    providers: [BetslipStateSaverService, BetslipStateLoaderService, BetslipSavedStateValidatorService, BetslipDisplayModeService],
})
export default class BetslipStorageModule {
    static forParent(storeConfigInjectionToken: InjectionToken<any>): ModuleWithProviders<BetslipStorageModule> {
        return {
            ngModule: BetslipStorageModule,
            providers: [
                {
                    provide: storeConfigInjectionToken,
                    useFactory: betslipStoreConfigFactory,
                    deps: [StoragePersister, BetslipStateLoaderService, BetslipSavedStateValidatorService],
                },
            ],
        };
    }
}

function betslipStoreConfigFactory(
    storagePersister: StoragePersister,
    betslipStateLoader: BetslipStateLoaderService,
    betslipSavedStateValidatorService: BetslipSavedStateValidatorService,
): StoreConfig<IBetslipState> {
    const state = storagePersister.load();

    //@ts-ignore ISavedState has no keys, so we need to bypass the compiler here.
    let savedState: IBetslipSavedState | undefined = state?.[betslipFeatureKey];
    savedState = betslipSavedStateValidatorService.validate(savedState);

    let initialState = betslipStateLoader.load(savedState);
    initialState = betslipSavedStateValidatorService.updateStateConfigs(initialState);

    return {
        initialState,
    };
}
